module.exports = __webpack_public_path__ + "img/horizontal-logo-white.f4d9b634.svg";